import axios from 'axios'

export const BASE_URL = (import.meta.env.VITE_BACKEND_API as string) ?? 'http://localhost:8001'

export const axiosInstance = axios.create({
  baseURL: BASE_URL,
})
